import { put, takeLatest } from 'redux-saga/effects';
import invoiceActionTypes from '../types';
import { fetchInvoicesClassLevelFailure, fetchInvoicesClassLevelSuccess } from '../actions';
import httpClient from '../../../utils/http-client';
import { handleError } from '../../../utils/utils';

export function* fetchInvoicesClassLevel({ payload }) {
  try {
    const response = yield httpClient.get('/class-levels', { params: payload });
    yield put(fetchInvoicesClassLevelSuccess(response.data));
  } catch (error) {
    yield put(fetchInvoicesClassLevelFailure(error?.message));
    const err = handleError(error);
  }
}

export function* onfetchInvoicesClassLevelStart() {
  yield takeLatest(invoiceActionTypes.FETCH_INVOICES_CLASS_LEVEL_START, fetchInvoicesClassLevel);
}
